<div class="p-4">
  <div class="operation-body">
    <ng-content></ng-content>
  </div>
  <div class="operation-footer flex text-gray-400 italic">
    <div>
      @if (reportId) {
        id: {{ reportId }}
      }
    </div>
    <div class="grow text-right">
      reported: {{ timestamp | date: 'dd MMM YYYY - hh:mm:ss' }}
    </div>
  </div>
</div>
